export enum PortalSettingEnum {
  String = 0,
  Boolean = 1,
}
